module.exports = __webpack_public_path__ + "img/card-placeholder-j4u.svg";